import * as tslib_1 from "tslib";
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Arrow } from 'react-popper';
import cx from 'classnames';
import { includes } from 'lodash';
import { checkPopoverArrowProp, componentType } from "../../../utils/propTypes";
import Popover from '../Popover';
import "./Tooltip.css";

var Tooltip =
/** @class */
function (_super) {
  tslib_1.__extends(Tooltip, _super);

  function Tooltip() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: _this.props.isOpen
    };

    _this.onOpen = function () {
      var _a = _this.props,
          delay = _a.delay,
          text = _a.text,
          disabled = _a.disabled;
      if (!text || disabled) return;

      var setOpen = function setOpen() {
        return _this.setState({
          isOpen: true
        });
      };

      if (delay) {
        _this.delayId = window.setTimeout(setOpen, delay);
      } else {
        setOpen();
      }
    };

    _this.onClose = function (event) {
      var keepTooltipOpen = _this.props.keepTooltipOpen;

      if (!keepTooltipOpen) {
        _this.setState({
          isOpen: false
        });
      } else if (!includes(event.relatedTarget.className, 'nx-popover') && !includes(event.relatedTarget.className, 'nx-tooltip__body')) {
        _this.setState({
          isOpen: false
        });
      }

      _this.clearDelayTimer();
    };

    _this.onClick = function (event) {
      var _a = _this.props,
          onClick = _a.onClick,
          shouldCloseOnClick = _a.shouldCloseOnClick;
      onClick && onClick(event);

      if (shouldCloseOnClick) {
        _this.setState({
          isOpen: false
        });

        _this.clearDelayTimer();
      }
    };

    _this.clearDelayTimer = function () {
      _this.delayId && clearTimeout(_this.delayId);
    };

    _this.renderBody = function () {
      return React.createElement("div", {
        className: "nx-tooltip__body"
      }, _this.props.text);
    };

    return _this;
  }

  Tooltip.prototype.componentWillReceiveProps = function (nextProps) {
    if (this.props.isOpen !== nextProps.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  };

  Tooltip.prototype.componentWillUnmount = function () {
    this.clearDelayTimer();
  };

  Tooltip.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        text = _a.text,
        disabled = _a.disabled,
        children = _a.children,
        className = _a.className,
        style = _a.style,
        placement = _a.placement,
        popper = _a.popper,
        dark = _a.dark,
        popoverClassName = _a.popoverClassName,
        arrow = _a.arrow,
        keepTooltipOpen = _a.keepTooltipOpen,
        targetClassName = _a.targetClassName,
        Component = _a.component,
        targetComponent = _a.targetComponent;
    var isOpen = !!text && !disabled && this.state.isOpen;
    var finalArrow = arrow === undefined ? !dark && React.createElement(Arrow, {
      className: "nx-tooltip__arrow"
    }) : arrow;
    var modifiers = keepTooltipOpen ? {
      keepTogether: {
        enabled: true
      }
    } : {};
    var content;

    if (Component === Fragment) {
      // no wrapper around children
      content = React.Children.map(children, function (child) {
        if (typeof child !== 'object') return child;
        return React.cloneElement(child, {
          className: cx(child.props.className, className),
          style: tslib_1.__assign({}, child.props.style, style),
          onMouseEnter: function onMouseEnter(e) {
            child.props.onMouseEnter && child.props.onMouseEnter(e);

            _this.onOpen();
          },
          onMouseLeave: function onMouseLeave(e) {
            child.props.onMouseLeave && child.props.onMouseLeave(e);

            _this.onClose(e);
          },
          onClick: function onClick(e) {
            child.props.onClick && child.props.onClick(e);

            _this.onClick(e);
          }
        });
      });
    } else {
      content = React.createElement(Component, {
        className: className,
        style: style,
        onMouseEnter: this.onOpen,
        onMouseLeave: this.onClose,
        onClick: this.onClick
      }, children);
    }

    return React.createElement(Popover, {
      className: cx(popoverClassName, 'nx-tooltip', {
        'nx-tooltip--theme-dark': dark
      }),
      isOpen: isOpen,
      body: this.renderBody,
      arrow: finalArrow,
      popper: tslib_1.__assign({
        placement: placement,
        modifiers: modifiers
      }, popper),
      onMouseEnter: keepTooltipOpen ? this.onOpen : undefined,
      onMouseLeave: keepTooltipOpen ? this.onClose : undefined,
      openOnClick: false,
      targetClassName: targetClassName,
      targetComponent: targetComponent
    }, content);
  };

  Tooltip.propTypes = {
    disabled: PropTypes.bool,
    text: PropTypes.any.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    isOpen: PropTypes.bool,
    shouldCloseOnClick: PropTypes.bool,
    placement: PropTypes.string,
    popper: PropTypes.object,
    onClick: PropTypes.func,
    popoverClassName: PropTypes.string,
    arrow: checkPopoverArrowProp,

    /**
     * Keep tooltip open when mouse leaves children,
     * but stays over the tooltip itself
     * */
    keepTooltipOpen: PropTypes.bool,
    delay: PropTypes.number,
    dark: PropTypes.bool,
    targetClassName: PropTypes.string,
    component: componentType,
    targetComponent: componentType
  };
  Tooltip.defaultProps = {
    isOpen: false,
    shouldCloseOnClick: false,
    placement: 'top',
    popper: {},
    dark: false,
    popoverClassName: '',
    keepTooltipOpen: false,
    component: 'div'
  };
  return Tooltip;
}(Component);

export default Tooltip;

try {
  // @ts-ignore
  Tooltip.__docgenInfo = {
    "description": "",
    "displayName": "Tooltip",
    "props": {
      "isOpen": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "isOpen",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "shouldCloseOnClick": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "shouldCloseOnClick",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "dark": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "dark",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "keepTooltipOpen": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "keepTooltipOpen",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "popoverClassName": {
        "defaultValue": {
          value: ""
        },
        "description": "",
        "name": "popoverClassName",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "targetClassName": {
        "defaultValue": null,
        "description": "",
        "name": "targetClassName",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "disabled": {
        "defaultValue": null,
        "description": "",
        "name": "disabled",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "text": {
        "defaultValue": null,
        "description": "",
        "name": "text",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "delay": {
        "defaultValue": null,
        "description": "",
        "name": "delay",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "onClick": {
        "defaultValue": null,
        "description": "",
        "name": "onClick",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<Element>) => void) | undefined"
        }
      },
      "style": {
        "defaultValue": null,
        "description": "",
        "name": "style",
        "required": false,
        "type": {
          "name": "CSSProperties | undefined"
        }
      },
      "placement": {
        "defaultValue": null,
        "description": "",
        "name": "placement",
        "required": true,
        "type": {
          "name": "\"top\" | \"auto-start\" | \"auto\" | \"auto-end\" | \"top-start\" | \"top-end\" | \"right-start\" | \"right\" | \"right-end\" | \"bottom-end\" | \"bottom\" | \"bottom-start\" | \"left-end\" | \"left\" | \"left-start\" | undefined"
        }
      },
      "popper": {
        "defaultValue": {
          value: "{}"
        },
        "description": "",
        "name": "popper",
        "required": true,
        "type": {
          "name": "IPopperProps"
        }
      },
      "arrow": {
        "defaultValue": null,
        "description": "",
        "name": "arrow",
        "required": false,
        "type": {
          "name": "false | ReactElement<ArrowProps> | undefined"
        }
      },
      "component": {
        "defaultValue": {
          value: "div"
        },
        "description": "",
        "name": "component",
        "required": true,
        "type": {
          "name": "ReactType<any>"
        }
      },
      "targetComponent": {
        "defaultValue": null,
        "description": "",
        "name": "targetComponent",
        "required": false,
        "type": {
          "name": "string | ComponentClass<any, any> | StatelessComponent<any> | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}